import { useAuth } from '@/stores/auth.store';
import { Directive } from 'vue';

/**
 * Custom directive to hide elements that are meant to only be seen by super admins
 */
export const vSuperAdmin: Directive = {
  mounted: (el) => {
    const auth = useAuth();
    el.style.display = auth.user?.isSuperAdmin ? '' : 'none';

    auth.$subscribe(() => {
      el.style.display = auth.user?.isSuperAdmin ? '' : 'none';
    });
  },
};
